var IsBoot = true;
export function reCaptcha(itemCaller, callback, action) {
    var CAPTCHA_PUB = document.getElementById("captchaPub").value;
    var CAPTCHA_SCORE = Number.parseFloat(document.getElementById("captchaScore").value);
    var CAPTCHA_V2_KEY = document.getElementById("captchaV2Key").value;
    
    grecaptcha.ready(function () {
        grecaptcha.execute(CAPTCHA_PUB, {action: action}).then(function(token) {
            $.ajax({
                type: 'POST',
                url: '/Recaptcha/VerifyTokenEnterprise',
                dataType: 'JSON',
                data: {
                    token: token,
                    action: action
                },
                success: successFunc,
                error: errorFunc
            });
            function successFunc(response) {
                if (response.riskAnalysis.score >= CAPTCHA_SCORE) {
                    IsBoot = false;
                    if (typeof callback !== "undefined") {
                        itemCaller.disabled = false;
                        callback();
                    }
                } else {
                    showCaptchaVII.call(itemCaller);
                }
            }

            function errorFunc(jQXHR, textStatus, errorThrown) {
                //deleteVII();
                console.log("An error occurred while trying to contact the server: " + jQXHR.status + " " + textStatus + " " + errorThrown);
                return false;
            }

            function showCaptchaVII() {
                if (IsBoot) {
                    if (document.getElementById("recDiv") === undefined || document.getElementById("recDiv") == null) {
                        var script = document.createElement("script");
                        script.src = "https://www.google.com/recaptcha/api.js" + '?hl=' + tech.core.getCookie(tech.core.COOKIE_LANGUAGE_CODE);
                        script.onload = script.onreadystatechange = function () {
                            var recpDiv;
                            var objTo = itemCaller;
                            var captchaContainer = document.getElementById("recDiv");
                            if (captchaContainer != null) {
                                captchaContainer.innerHTML = "";
                            } else {
                                recpDiv = document.createElement("div");
                            }
                            recpDiv.setAttribute("id", "recDiv");
                            recpDiv.setAttribute("style", "margin: 0 auto;");
                            objTo.appendChild(recpDiv);
                            grecaptcha.enterprise.render(document.getElementById("recDiv"), {
                                'sitekey': CAPTCHA_V2_KEY,
                                'callback': callback,
                            });
                        }
                        var body = document.getElementsByTagName("body")[0];
                        (body || document.body).appendChild(script);
                    }
                } else {
                    itemCaller.disabled = false;
                    callback();
                }
            }
        })
    })
}